import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { API_BASE_URL } from "../../config/api";
import {
  faChartLine,
  faUsers,
  faBookOpen,
  faAward,
  faHouse,
  faUserShield,
  faRightFromBracket,
  faClipboardList,
  faLayerGroup
} from "@fortawesome/free-solid-svg-icons";

function SideBar(props) {
  const { current } = props;
  const navigate = useNavigate();
  const adminRole = localStorage.getItem("adminRole");
  const isMain = adminRole === "main";
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    if (isMain) {
      fetch(`${API_BASE_URL}/api/registrations/pending/count`)
        .then((r) => r.json())
        .then((data) => setPendingCount(data.count || 0))
        .catch(() => {});
    }
  }, [isMain]);

  const handleLogout = () => {
    localStorage.removeItem("adminId");
    localStorage.removeItem("adminName");
    localStorage.removeItem("adminEmail");
    localStorage.removeItem("adminRole");
    navigate("/admin-login");
  };

  return (
    <div id="sidebar">
      {/* Brand Header */}
      <Link
        to="/"
        className="brand a"
        style={{
          padding: "16px 20px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          textDecoration: "none",
          borderBottom: "1px solid #f1f5f9"
        }}
      >
        <img
          src="/consortiumelearning.png"
          alt="Consortium Logo"
          style={{ height: "36px", width: "auto", objectFit: "contain", flexShrink: 0 }}
        />
        <div style={{ display: "flex", flexDirection: "column", textAlign: "left", justifyContent: "center", lineHeight: "1" }}>
          <span
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontWeight: 800,
              fontSize: "1.05rem",
              color: "#0f172a",
              lineHeight: "1",
              margin: 0
            }}
          >
            Consortium
          </span>
          <span
            style={{
              fontSize: "0.6rem",
              fontWeight: 700,
              color: "#4f46e5",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              lineHeight: "0.5",
              marginTop: "4px"
            }}
          >
            ADMIN PANEL
          </span>
        </div>
      </Link>

      {/* Navigation Menu */}
      <ul className="side-menu" style={{ marginTop: "16px", padding: "0 14px", listStyle: "none" }}>
        {/* Dashboard — visible to all admins */}
        <li className={current === "dashboard" ? "active" : ""}>
          <Link to="/dashboard" className="a">
            <FontAwesomeIcon icon={faChartLine} className="menu-icon" />
            <span className="text">Dashboard</span>
          </Link>
        </li>

        {/* Manage Users — Main Admin only */}
        {isMain && (
          <li className={current === "user" ? "active" : ""}>
            <Link to="/Dusers" className="a">
              <FontAwesomeIcon icon={faUsers} className="menu-icon" />
              <span className="text">Manage Users</span>
            </Link>
          </li>
        )}

        {/* Manage Courses — visible to all admins */}
        <li className={current === "courses" ? "active" : ""}>
          <Link to="/DCourses" className="a">
            <FontAwesomeIcon icon={faBookOpen} className="menu-icon" />
            <span className="text">Manage Courses</span>
          </Link>
        </li>

        {/* Manage Categories — visible to all admins */}
        <li className={current === "categories" ? "active" : ""}>
          <Link to="/Dcategories" className="a">
            <FontAwesomeIcon icon={faLayerGroup} className="menu-icon" />
            <span className="text">Categories</span>
          </Link>
        </li>

        {/* Course Completions — Main Admin only */}
        {isMain && (
          <li className={current === "completions" ? "active" : ""}>
            <Link to="/Dcompletions" className="a">
              <FontAwesomeIcon icon={faAward} className="menu-icon" />
              <span className="text">Completions</span>
            </Link>
          </li>
        )}

        {/* Admin Management — Main Admin only */}
        {isMain && (
          <li className={current === "admins" ? "active" : ""}>
            <Link to="/Dadmins" className="a">
              <FontAwesomeIcon icon={faUserShield} className="menu-icon" />
              <span className="text">Manage Admins</span>
            </Link>
          </li>
        )}

        {/* Registration Requests — Main Admin only */}
        {isMain && (
          <li className={current === "registrations" ? "active" : ""}>
            <Link to="/Dregistrations" className="a" style={{ position: "relative" }}>
              <FontAwesomeIcon icon={faClipboardList} className="menu-icon" />
              <span className="text">Registrations</span>
              {pendingCount > 0 && (
                <span style={{
                  background: "#ef4444", color: "#fff", fontSize: "0.7rem", fontWeight: 700,
                  padding: "2px 7px", borderRadius: "10px", marginLeft: "auto"
                }}>
                  {pendingCount}
                </span>
              )}
            </Link>
          </li>
        )}

        {/* Divider + Utility Links */}
        <li style={{ marginTop: "24px", borderTop: "1px solid #f1f5f9", paddingTop: "16px" }}>
          <Link to="/" className="a">
            <FontAwesomeIcon icon={faHouse} className="menu-icon" style={{ color: "#64748b" }} />
            <span className="text" style={{ color: "#64748b" }}>Main Site</span>
          </Link>
        </li>

        <li>
          <div
            className="a"
            onClick={handleLogout}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faRightFromBracket} className="menu-icon" style={{ color: "#ef4444" }} />
            <span className="text" style={{ color: "#ef4444", fontWeight: 700 }}>Logout</span>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default SideBar;